<template>
    <div
        id="app"
        class="wrapper"
    >
        <spinner v-if="loadingSpinner.show"></spinner>

        <template v-if="isDesktop">
            <si-header v-if="$route.name !== 'rules'"></si-header>
            <router-view v-if="ready" :rules="data"/>

            <si-pop-up
                v-if="popup"
                @back="toggleTimer"
            ></si-pop-up>

            <si-footer
                v-if="$route.name !== 'rules'"
                @openOverlay="openOverlay"
            ></si-footer>
            <si-overlay
                v-if="$route.name !== 'rules' && overlay"
                @closeOverlay="overlay = false"
                :type="type"
                :data="data"
            ></si-overlay>
        </template>

        <template v-else>
            <div class="wrapper__is-mobile" v-if="$route.name !== 'rules'">
                <img src="/images/mobile.png" />
            </div>
            <router-view
                v-if="ready && $route.name === 'rules'"
                :rules="data"
            />
        </template>
  </div>
</template>

<script>
    import CONFIG from '@/config';
    import LoadingSpinner from '@/services/loading-spinner.service';
    import Spinner from '@/components/Spinner.vue';
    import Preloader from '@/services/preloader.service';
    import bus from '@/services/bus.service';
    import defer from 'promise-defer';
    import Header from '@/components/Header.vue';
    import PopUp from '@/components/PopUp.vue';
    import Footer from '@/components/Footer.vue';
    import Overlay from '@/components/Overlay.vue';
    import axios from 'axios';

  export default {

    name: 'App',

    data () {

      return {
        images: CONFIG.images,
        ready: false,
        loadingSpinner: LoadingSpinner.spinner,
        isDesktop: true,
        defers: {
          imagesReady: new defer(),
          gaReady: new defer()
        },
        time: CONFIG.settings.timeout,
        timeout: null,
        popup: false,
        overlay: false,
        data: null,
        type: 'privacy'
      };
    },

    mounted() {
        const vm = this;

        let gaReady = setInterval(() => {
            if (typeof window.ga !== 'undefined') {
                clearInterval(gaReady);
                vm.defers.gaReady.resolve();
            }
        });

        console.log('Current Date: ' + (CONFIG.settings.date !== null ? new Date(CONFIG.settings.date) : new Date()));

        vm.checkWidth();

        if (this.isDesktop && window.innerHeight <= 650) {
            document.body.classList.add('overflow-y');
        }

        axios({
            method: 'GET',
            url: 'data.json'
        }).then(data => {
            vm.data = data.data.POST.parameters.legal;
        });
    },

    created() {
        const vm = this;

        Preloader.bind(vm.images.preload, {
            complete() {
                console.log('Base Images preloaded!', vm.images.preload);
                vm.defers.imagesReady.resolve();
            },
            error() {
                console.log('Failed to load one or more images!');
            }
        });

        Preloader.bind(vm.images.subsequent, {
            complete() {
                console.log('Base Subsequent images Loaded!', vm.images.subsequent);
            },
            error() {
                console.log('Failed to load one or more images!');
            }
        });

        Promise.all([
            vm.defers.imagesReady.promise,
            vm.defers.gaReady.promise
        ]).then(() => {
            vm.onDataReady();
        });

        window.addEventListener('resize', this.checkWidth.bind(this));
    },

    methods: {

        setTimeout() {
            this.timeout = setTimeout(() => {
                this.toggleTimer(true);
                clearTimeout();
                this.timeout = null;
            }, this.time);
        },

        checkWidth() {
            if (window.innerWidth < 1000) {
                this.isDesktop = false;
            } else {
                this.isDesktop = true;
            }
        },

        onDataReady() {
            this.ready = true;

            bus.$on('resetTimeout', this.setTimeout.bind(this));

            bus.$on('openOverlay', type => {
                this.type = type;
                this.overlay = true;
            });
        },

        toggleTimer(val) {
            this.popup = val;

            if (val) {
                bus.$emit('resetTimeout', true);
            }
        },

        openOverlay(type) {
            this.overlay = true
            this.type = type;
        }
    },

    components: {
      Spinner,
      SiHeader: Header,
      SiPopUp: PopUp,
      SiFooter: Footer,
      SiOverlay: Overlay
    }
  };
</script>

<style lang="scss">
  * {
    margin: 0;
    padding: 0;

    &:focus {
      outline: none;
    }
  }

    html,
    body {
        width: 100%;
        height: 100%;
    }

    body {
        background: #fce239 url('/images/reskin-pattern.svg') repeat-x;
        background-size: 1000px;
        overflow: hidden;

        &.overflow-y {
            overflow-y: scroll;
        }
    }

    .snackbar[class*=top] {
        top: 140px !important;
    }

  .wrapper {
    background-repeat: no-repeat;
    background-position: 50% bottom;
    height: 100%;
    margin: 0px auto;
    overflow: hidden;
    position: relative;
    width: 100%;

    &__is-mobile {
      align-items: center;
      display: flex;
      height: 100vh;
      justify-content: center;
      width: 100vw;

      img {
        max-width: 100%;
        height: auto;

        @media (orientation: landscape) {
          height: 100%;
          width: auto;
        }
      }
    }

    &__btn {
      background-color: transparent;
      border: none;
      cursor: pointer;
    }

    &__container {
        height: 650px;
        margin: 0px auto;
        position: relative;
        width: 1000px;
    }

    &__mask-submission .sub,
    &__closed .sub {
        font-size: 16px;
    }
  }
</style>
